import React from 'react';
import { Helmet } from 'react-helmet';
import './pagestyles/InclusionAtRedboxGlobal.css';

const InclusionAtRedboxGlobal = () => {
  return (
    <>
      <Helmet>
        <title>Inclusion at Redbox Global - Diversity, Equity & Belonging | Redbox Global</title>
        <meta name="description" content="Learn about Redbox Global's commitment to diversity, equity, and inclusion. Discover our initiatives, employee resource groups, and how we're building a workplace where everyone belongs." />
        <meta name="keywords" content="diversity and inclusion, workplace diversity, equity and inclusion, DEI initiatives, employee resource groups, inclusive workplace, Redbox Global diversity, belonging at work" />
        
        {/* Open Graph / Facebook */}
        <meta property="og:type" content="website" />
        <meta property="og:url" content="https://redboxglobal.com/inclusion" />
        <meta property="og:title" content="Inclusion at Redbox Global - Diversity, Equity & Belonging" />
        <meta property="og:description" content="Discover how Redbox Global fosters an inclusive environment where diverse perspectives drive innovation and excellence in business journalism." />
        <meta property="og:image" content="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&h=630&fit=crop" />
        
        {/* Twitter */}
        <meta name="twitter:card" content="summary_large_image" />
        <meta name="twitter:url" content="https://redboxglobal.com/inclusion" />
        <meta name="twitter:title" content="Inclusion at Redbox Global - Diversity, Equity & Belonging" />
        <meta name="twitter:description" content="Learn about our commitment to creating an inclusive workplace where everyone can thrive." />
        <meta name="twitter:image" content="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&h=630&fit=crop" />
        
        {/* Additional SEO */}
        <meta name="robots" content="index, follow" />
        <meta name="author" content="Redbox Global" />
        <link rel="canonical" href="https://redboxglobal.com/inclusion" />
        
        {/* Structured Data for Organization */}
        <script type="application/ld+json">
          {JSON.stringify({
            "@context": "https://schema.org",
            "@type": "WebPage",
            "name": "Inclusion at Redbox Global",
            "description": "Learn about Redbox Global's commitment to diversity, equity, and inclusion initiatives.",
            "url": "https://redboxglobal.com/inclusion",
            "publisher": {
              "@type": "Organization",
              "name": "Redbox Global",
              "logo": {
                "@type": "ImageObject",
                "url": "https://redboxglobal.com/logo.png"
              }
            }
          })}
        </script>
      </Helmet>
      
      <div className="page-container">
      <div className="page-header">
        <h1>Inclusion at Redbox Global</h1>
        <p className="page-subtitle">Building a diverse, equitable, and inclusive workplace where everyone thrives</p>
      </div>
      
      <div className="page-content">
        <a href="/article/dei-strategy-2026" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
          <div className="featured-article">
            <div className="featured-image">
              <img src="https://images.unsplash.com/photo-1529156069898-49953e39b3ac?w=1200&h=600&fit=crop" alt="Diverse team collaboration" />
            </div>
            <div className="featured-content">
              
              <h2>Diversity, Equity & Inclusion: The Redbox Global Way</h2>
              <p>At Redbox Global, we believe that diversity of thought, background, and experience makes us stronger. Learn about our comprehensive DEI strategy, employee resource groups, and how we're creating a culture where every voice is heard and valued.</p>
              <span className="article-meta">Leadership Statement</span>
            </div>
          </div>
        </a>

        <div className="content-grid">
          <a href="/article/employee-resource-groups" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1573496359142-b8d87734a5a2?w=600&h=400&fit=crop" alt="Employee Resource Groups" />
              </div>
              <div className="article-content">
               
                <h2>Employee Resource Groups: Voices That Shape Our Culture</h2>
                <p>Explore our employee-led resource groups focused on supporting women, LGBTQ+ employees, people of color, veterans, and individuals with disabilities.</p>
                <span className="article-meta">Join Our ERGs</span>
              </div>
            </article>
          </a>

          <a href="/article/inclusive-recruitment" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1560250097-0b93528c311a?w=600&h=400&fit=crop" alt="Inclusive Recruitment" />
              </div>
              <div className="article-content">
             
                <h2>Building Diverse Teams From the Ground Up</h2>
                <p>Discover how our inclusive recruitment practices and partnerships with diverse organizations help us attract and retain top talent from all backgrounds.</p>
                <span className="article-meta">Our Approach</span>
              </div>
            </article>
          </a>

          <a href="/article/dei-impact-report-2025" style={{ textDecoration: 'none', color: 'inherit', display: 'block' }}>
            <article className="article-card">
              <div className="article-image">
                <img src="https://images.unsplash.com/photo-1454165804606-c3d57bc86b40?w=600&h=400&fit=crop" alt="DEI Impact Report" />
              </div>
              <div className="article-content">
               
                <h2>2025 Diversity & Inclusion Impact Report</h2>
                <p>View our annual progress on diversity metrics, inclusion initiatives, pay equity analysis, and our goals for creating lasting change at Redbox Global.</p>
                <span className="article-meta">Read Full Report</span>
              </div>
            </article>
          </a>
        </div>
      </div>
    </div>
    </>
  );
};

export default InclusionAtRedboxGlobal;
